import type { ReactNode } from "react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type ChatInlineAlertProps = {
  variant?: "default" | "destructive";
  children: ReactNode;
  onDismiss?: () => void;
  dismissLabel?: string;
  className?: string;
};

export function ChatInlineAlert({
  variant = "default",
  children,
  onDismiss,
  dismissLabel = "Dismiss",
  className,
}: ChatInlineAlertProps) {
  return (
    <Alert variant={variant} className={cn("mb-3 flex items-start gap-2", className)}>
      <AlertDescription className="min-w-0 flex-1">{children}</AlertDescription>
      {onDismiss ? (
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-6 shrink-0 px-2 text-xs"
          onClick={onDismiss}
          aria-label={dismissLabel}
        >
          {dismissLabel}
        </Button>
      ) : null}
    </Alert>
  );
}
